import React, { useContext, useEffect } from "react";
import { ConfigOptions } from "../../App";
import { ProductCategories } from "../../const/InitialCalcConfig";
import { BasicTable } from "../BasicTable";
import { StandardTable } from "../StandardTable";
import styled from "styled-components/macro";
import { t } from "../../utils/intl";

interface RestTable {
  [key: string]: number;
}
interface IProps {
  selectedProduct: ProductCategories;
  calculationResult: RestTable[];
}

export const OfferComponent = ({ selectedProduct, calculationResult }: IProps) => {
  const { templateConfigMap } = useContext(ConfigOptions);
  const { REACT_APP_TITLE } = process.env;

  useEffect(() => {
    document.title = `${t("form.calculation")} ${t("productCategory." + selectedProduct)}`;
    return () => {
      document.title = REACT_APP_TITLE;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const RenderTable = () => {
    switch (templateConfigMap[selectedProduct].tableType) {
      case "Basic":
        return <BasicTable calculationResult={calculationResult} />;
      case "Standard":
        return <StandardTable calculationResult={calculationResult} />;
      default:
        break;
    }
  };

  return (
    <Wrapper>
      <div>
        {RenderTable()}
        <PrintScreenButtonContainer onClick={() => window.print()}>
          <PrintScreenButton>{t("form.print")}</PrintScreenButton>
        </PrintScreenButtonContainer>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-top: 80px;
`;

const PrintScreenButtonContainer = styled.div`
  margin-top: 24px;

  @media print {
    display: none;
  }
`;

const PrintScreenButton = styled.span`
  color: ${({ theme }) => theme.colors.darkGreen};
  font-size: 16px;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    background: ${({ theme }) => theme.colors.darkGreen};
    height: 1px;
    width: 100%;
    left: 0;
    bottom: 4px;
  }
`;
